import makeStyles from 'e100-react-components/lib/styles/makeStyles';

export const useStyles = makeStyles(({ spacing, typography }) => ({
  iconContainer: {
    minWidth: spacing(5),
    lineHeight: typography.h3.lineHeight
  },
  favouriteStationsIconContainer: {
    marginLeft: 'auto',
    position: 'relative',
    top: spacing(.5)
  }
}));
